import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'core/core.module';
import { DocumentsService } from './documents.service';
import { DocumentsQuestionsService } from './documents-questions.service';
import { DocumentsListComponent } from './documents-list/documents-list.component';
import { DocumentsRoutingModule } from './documents-routing.module';
import { DocumentEditorComponent } from './document-editor/document-editor.component';
import { DocumentDetailComponent } from './document-detail/document-detail.component';
import { DocumentsListRowComponent } from './documents-list/documents-list-row/documents-list-row.component';
import { DocumentCreateComponent } from './document-create/document-create.component';
import { QuestionsModule } from '../questions/questions.module';
import { DocumentsListDetailComponent } from './documents-list/documents-list-detail/documents-list-detail.component';

@NgModule({
  imports: [CommonModule, CoreModule, DocumentsRoutingModule, QuestionsModule],
  declarations: [
    DocumentsListComponent,
    DocumentEditorComponent,
    DocumentDetailComponent,
    DocumentsListRowComponent,
    DocumentCreateComponent,
    DocumentsListDetailComponent
  ],
  exports: [DocumentsListComponent, DocumentCreateComponent],
  providers: [DocumentsService, DocumentsQuestionsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DocumentsModule {}
